import PropTypes from 'prop-types'
import { tr } from 'react-hook-form-auto'

import { MealTag } from '../MealTag'
import { FlexList } from '../../../components/FlexList'

const renderResults = ({
  col,
  onSelect,
  search,
  RenderComponent,
  selectedIdx
}) => {
  if (col.length > 0) {
    return col.map((doc, idx) => {
      const props = {
        key: doc.id,
        doc,
        onClick: onSelect.bind(null, doc),
        inline: true,
        selected: idx == selectedIdx,
        search
      }

      return (
        <RenderComponent key={doc.id} {...props} />
      )
    })
  }
}

const renderMealList = (params) => {
  const { col } = params

  if (col && col.length > 0)
    return renderResults(params)
  else
    return null
}

export const MealsList = ({
  loading,
  meals = [],
  search,
  searching,
  onSelect,
  onAddSelected,
  onResults,
  listWrapper,
  mealRenderer,
  selectedIdx
}) => {
  const Wrapper = listWrapper || FlexList
  const RenderComponent = mealRenderer || MealTag

  const ingElements = meals ? renderMealList({
    col: meals,
    onSelect,
    RenderComponent,
    selectedIdx
  }) : []

  if (onResults)
    onResults(meals)

  return (
    <Wrapper>
      {ingElements}
      <RenderComponent
        text={tr('add')}
        onClick={onAddSelected}
        isAdd
        inline
      />
    </Wrapper>
  )
}

MealsList.propTypes = {
  loading: PropTypes.bool,
  meals: PropTypes.array,
  onSelect: PropTypes.func,
  onAddSelected: PropTypes.func
}
